<div class="container mt-lg-4 mt-4">

  <div class="container mt-lg-4 mt-4 mb-4">
    <div class="mb-3">
      <p-toolbar>
        <div class="ui-toolbar-group-left">
          <h4 class="mb-0" *ngIf="this.projectType==this.projectTypeEnum.IBK">IBK Projekte bearbeiten</h4>
          <h4 class="mb-0" *ngIf="this.projectType==this.projectTypeEnum.KP">Kleinprojekte Projekte bearbeiten</h4>
        </div>
        <div class="ui-toolbar-group-right">
          <button pButton type="button" class="ui-button-secondary" label=" Neues Projekt" (click)="addProject(null)" icon="pi pi-plus"></button>
        </div>
      </p-toolbar>
    </div>



    <p-table #dt [value]="projects" [paginator]="true" [rows]="10" [globalFilterFields]="['ProjectId','ProjectName']">
      <ng-template pTemplate="caption">
        <div style="text-align: right">
          <i class="pi pi-search" style="margin:4px 4px 0 0"></i>
          <input type="text" pInputText size="50" placeholder="Suchen" (input)="dt.filterGlobal($event.target.value, 'contains')" style="width:auto">
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style="width:150px;">Nr.</th>
          <th>Projekt</th>
          <th style="width:100px;">Edit</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-project>
        <tr>
          <td style="width:150px;">{{ project.ProjectId }}</td>
          <td>
            {{ project.ProjectName }}
          </td>
          <td style="width:100px;"><button pButton type="button" class="ui-button-primary" (click)="editProject(project)" icon="pi pi-pencil" title="Projekt bearbeiten"></button></td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <div *ngIf="spinner2" style="text-align:center;width:100%">Lade Projekte</div>

  <p-dialog [header]="projectTitle" [(visible)]="showEditor" (onHide)="cancelProject()" [focusOnShow]="false" [responsive]="true" showEffect="fade" [modal]="true" [style]="{height:'70%',width: '1000px'}" [contentStyle]="{height:'100%'}">

    <p-tabView #tabview [(activeIndex)]="indexTabView" (onChange)="onChangeTab($event)">
      <p-tabPanel header="Projekt Daten" leftIcon="pi pi-file" [selected]="true">
        <div class="container" *ngIf="selectedProject">
          <div class="row mt-3">
            <div class="col-3">
              <label for="projectID">Projekt Id:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectID" name="projectID" [(ngModel)]="this.selectedProject.ProjectId" />
              <p-message severity="error" text="" *ngIf="!hasData(this.selectedProject.ProjectId)"></p-message>
            </div>
          </div>


          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectCategorie">Kategorie:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectCategory" [(ngModel)]="this.selectedProject.Category" filter="true" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-3">
              <label for="projectName">Name:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectName" name="projectName" [(ngModel)]="this.selectedProject.ProjectName" style="width:90%" />
              <p-message severity="error" text="" *ngIf="!hasData(this.selectedProject.ProjectName)"></p-message>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputIBK">
            <div class="col-3">
              <label for="projectResponsible">Verantwortlich:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectResponsible" [(ngModel)]="this.selectedProject.Responsible" filter="true" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputIBK">
            <div class="col-3">
              <label for="projectLinkResponsible">Link Verantwortlich:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectLinkResponsible" name="projectLinkResponsible" [(ngModel)]="this.selectedProject.LinkResponsible" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-3">
              <label for="projectTopic">Thema:</label>
            </div>
            <div class="col-9">
              <p-multiSelect [options]="projectTopics" [(ngModel)]="selectedProjectTopic" [style]="{'width': '90%'}"></p-multiSelect>
              <!--<p>Selecteded Topics: selectedProjectTopic</p>-->
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputIBK">
            <div class="col-3">
              <label for="projectStrategyFocus">Strategie Schwerpunkt:</label>
            </div>
            <div class="col-9">
              <p-multiSelect [options]="projectStrategyFocus" [(ngModel)]="selectedProjectStrategyFocus" [style]="{'width': '90%'}"></p-multiSelect>
              <!--<p>Selecteded Topics: selectedProjectStrategyFocus</p>-->
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLink">Link Projekt:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectLink" name="projectLink" [(ngModel)]="this.selectedProject.LinkProject" style="width:90%" />
            </div>

          </div>


          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLink">Start Datum:</label>
            </div>
            <div class="col-9">
              <p-calendar [(ngModel)]="this.selectedProject.StartDate" [showIcon]="true" dateFormat="dd.mm.yy" [style]="{'height': '90%'}"></p-calendar>
              <p-message severity="error" text="" *ngIf="!hasData2(this.selectedProject.StartDate)"></p-message>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLink">End Datum:</label>
            </div>
            <div class="col-9">
              <p-calendar #calEndDate [(ngModel)]="this.selectedProject.EndDate" dateFormat="dd.mm.yy" [showIcon]="true"></p-calendar>
              <button pButton type="button" label="X" (click)="removeProjectEndDate()" class="ui-button-danger" style="margin-left:10px;" title="Datum entfernen" *ngIf="this.selectedProject.EndDate!=null"></button>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLink">Beschreibung:</label>
            </div>
            <div class="col-9">
              <textarea pInputTextarea id="projectDescription" name="projectDescription" [(ngModel)]="this.selectedProject.ProjectDescription" style="width:90%;height:400px;"></textarea>
            </div>
          </div>

          <!-- KP -->
          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectSelectionCriteria">Auswahlkriterium:</label>
            </div>
            <div class="col-9">
              <p-multiSelect [options]="projectSelectionCriteria" [(ngModel)]="selectedprojectSelectionCriteria" [style]="{'width': '90%'}"></p-multiSelect>
            </div>
          </div>


          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectCategorie">Interreg Periode:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectInterregPeriode" [(ngModel)]="this.selectedProject.InterregPeriode" filter="true" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectAidAmount">Förderbetrag:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectAidAmount" name="projectAidAmount" [(ngModel)]="this.selectedProject.AidAmount" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectApplicant">Antragsteller:</label>
            </div>
            <div class="col-9">
              <textarea pInputTextarea id="projectApplicant" name="projectApplicant" [(ngModel)]="this.selectedProject.Applicant" style="width:90%;height:100px;"></textarea>
            </div>
          </div>


          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectApplicantStatus">Status Antragsteller:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectApplicantStatus" [(ngModel)]="this.selectedProject.ApplicantStatus" filter="true" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectApplicantRegion">Region Antragsteller:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectApplicantRegion" [(ngModel)]="this.selectedProject.ApplicantRegion" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectApplicantLink">Link Antragsteller:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectApplicantLink" name="projectApplicantLink" [(ngModel)]="this.selectedProject.ApplicantLink" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner1">Partner 1:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectPartner1" name="projectPartner1" [(ngModel)]="this.selectedProject.Partner1" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner1Region">Partner 1 Region:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectPartnerRegion" [(ngModel)]="this.selectedProject.Partner1Region" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner1Link">Partner 1 Link:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectPartner1Link" name="projectPartner1Link" [(ngModel)]="this.selectedProject.Partner1Link" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner2">Partner 2:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectPartner2" name="projectPartner2" [(ngModel)]="this.selectedProject.Partner2" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner2Region">Partner 2 Region:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectPartnerRegion" [(ngModel)]="this.selectedProject.Partner2Region" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner2Link">Partner 2 Link:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectPartner2Link" name="projectPartner2Link" [(ngModel)]="this.selectedProject.Partner2Link" style="width:90%" />
            </div>
          </div>



          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner3">Partner 3:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectPartner3" name="projectPartner3" [(ngModel)]="this.selectedProject.Partner3" style="width:90%" />
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner3Region">Partner 3 Region:</label>
            </div>
            <div class="col-9">
              <p-dropdown [options]="projectPartnerRegion" [(ngModel)]="this.selectedProject.Partner3Region" [style]="{'width': '90%'}"></p-dropdown>
            </div>
          </div>

          <div class="row mt-3" *ngIf="this.showInputKP">
            <div class="col-3">
              <label for="projectPartner3Link">Partner 3 Link:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectPartner3Link" name="projectPartner3Link" [(ngModel)]="this.selectedProject.Partner3Link" style="width:90%" />
            </div>
          </div>


        </div>
      </p-tabPanel>

      <p-tabPanel header="Medien" leftIcon="pi pi-folder" [disabled]="this.newProject">
        <div class="pi pi-upload" (click)="showhideUpload()" style="float:left;margin-bottom:10px;cursor:pointer;"><span class="mediaupload">Datei Upload</span></div>
        <div (click)="showhideUpload()" style="float:right;margin-bottom:10px;cursor:pointer;" *ngIf="showUpload"><span class="fa fa-times"></span></div>
        <div style="clear:both"></div>
        <p-fileUpload chooseLabel="Auswählen" uploadLabel="Hochladen" cancelLabel="Abbrechen" name="uploadProjectFiles[]" [url]="uploadURL" (onUpload)="uploadDone()" [style]="{'margin-bottom': '25px','margin-top':'10px'}" *ngIf="showUpload"></p-fileUpload>

        <div style="margin-bottom:20px;"></div>
        <p-table [value]="selectedProjectFiles" (onEditComplete)="saveProjectFilesEdited($event)">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:50px;">Pos</th>
              <th style="width:120px;">Projekt-Bild</th>
              <th>Name</th>
              <th style="width:75px;">Größe</th>
              <th style="width:75px;">Edit</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-pfile>
            <tr>

              <td style="width:50px;" [pEditableColumn]="pfile">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText type="text" [(ngModel)]="pfile.Pos">
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ pfile.Pos }}
                  </ng-template>

                </p-cellEditor>
              </td>

              <td style="width:50px;" [pEditableColumn]="pfile">
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <div style="text-align:center">
                      <input type="checkbox"
                             [checked]="(pfile.ProjectImage === '1') ? true : false"
                             (change)="pfile.ProjectImage = ($event.target.checked === true ? 1 : 0)" />
                    </div>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <!--<div style="text-align:center">
                       (pfile.ProjectImage === '1' ? 'X' : '')
                    </div>-->
                    <div *ngIf="pfile.ProjectImage === '1'" style="text-align:center">
                      <i class="fa fa-check-square-o" style="color: #21b384" aria-hidden="true"></i>
                    </div>
                  </ng-template>

                </p-cellEditor>
              </td>

              <td>

                {{ pfile.Filename }}
              </td>
              <td style="width:75px;">{{ pfile.Filesize }}</td>
              <td style="width:75px;">
                <button pButton type="button" class="ui-button-primary" (click)="deleteFile(pfile)" icon="pi pi-trash" title="Datei löschen"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="YouTube" leftIcon="pi pi-folder" [disabled]="this.newProject">
        <div class="pi pi-video" (click)="showhideVideo()" style="margin-bottom:10px;cursor:pointer;"><span class="mediaupload">YouTube Video</span></div>
        <div *ngIf="showVideo">
          <div class="row mt-3">
            <div class="col-3">
              <label for="projectVideoPos">Pos:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectVideoPos" name="projectVideoPos" [(ngModel)]="this.selectedProjectVideo.Pos" />
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-3">
              <label for="projectVideoname">Name:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectVideoname" name="projectVideoname" [(ngModel)]="this.selectedProjectVideo.Name" style="width:90%" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3">
              <label for="projectVideoEmbedCode">Video Embed HTML Code:</label>
            </div>
            <div class="col-9">
              <textarea pInputTextarea id="projectVideoEmbedCode" name="projectVideoEmbedCode" [(ngModel)]="this.selectedProjectVideo.EmbedCode" style="width:90%;height:200px;"></textarea>
            </div>
          </div>

          <p-footer>
            <div class="ui-dialog-buttonpane ui-helper-clearfix mt-1 mb-1">
              <button type="button" pButton icon="pi pi-check" (click)="saveVideoEmbedCode()" label="  Speichern"></button>
              <button type="button" pButton icon="pi pi-times" (click)="cancelVideoEmbedCode()" label="  Abbrechen" style="margin-left:10px;"></button>
              <button type="button" pButton icon="pi pi-trash" (click)="deleteVideoEmbedCode()" label="  Löschen" style="margin-left:10px" *ngIf="this.selectedProjectVideo.vId!=''"></button>
            </div>
          </p-footer>

        </div>

        <p-table [value]="selectedProjectVideos">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:50px;">Pos</th>
              <th>Name</th>
              <th style="width:75px;">Edit</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-pvideo>
            <tr>
              <td style="width:50px;">{{ pvideo.Pos }}</td>
              <td>
                {{ pvideo.Name }}
              </td>
              <td style="width:75px;">
                <button pButton type="button" class="ui-button-primary" (click)="editVideoEmbedCode(pvideo)" icon="pi pi-pencil" title="Video bearbeiten"></button>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-tabPanel>
      <p-tabPanel header="Links" leftIcon="pi pi-folder" *ngIf="this.showInputKP" [disabled]="this.newProject">
        <div class="pi pi-external-link" (click)="showhideLinkEditor()" style="margin-bottom:10px;cursor:pointer;"><span class="mediaupload">Link</span></div>
        <div *ngIf="showLinkEditor">
          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLinkPos">Pos:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectLinkPos" name="projectLinkPos" [(ngModel)]="this.selectedProjectLink.Pos" style="width:90%" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLinkname">Linkname:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectLinkname" name="projectLinkname" [(ngModel)]="this.selectedProjectLink.Linkname" style="width:90%" />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-3">
              <label for="projectLinkURL">URL:</label>
            </div>
            <div class="col-9">
              <input pInputText id="projectLinkURL" name="projectLinkURL" [(ngModel)]="this.selectedProjectLink.URL" style="width:90%" />
            </div>
          </div>
          <!--<div class="row mt-3">
          <div class="col-3">
            <label for="projectPartnerRegion">Region:</label>
          </div>
          <div class="col-9">
            <p-multiSelect [options]="projectPartnerRegion" [(ngModel)]="selectedProjectPartnerRegion" [style]="{'width': '90%'}"></p-multiSelect>-->
          <!--<p>Selecteded Topics: selectedProjectTopic</p>-->
          <!--</div>

          </div>-->

          <p-footer>
            <div class="ui-dialog-buttonpane ui-helper-clearfix mt-1 mb-1">
              <button type="button" pButton icon="pi pi-check" (click)="saveProjectLink()" label="  Speichern"></button>
              <button type="button" pButton icon="pi pi-times" (click)="cancelLink()" label="  Abbrechen" style="margin-left:10px;"></button>
              <button type="button" pButton icon="pi pi-trash" (click)="deleteLink()" label="  Löschen" style="margin-left:10px" *ngIf="this.selectedProjectLink.lId!=''"></button>
            </div>
          </p-footer>
        </div>
        <p-table [value]="selectedProjectLinks" [style]="{'margin-top': '25px'}">
          <ng-template pTemplate="header">
            <tr>
              <th style="width:50px;">Pos</th>
              <th style="width:175px;">Name</th>
              <th>URL</th>
              <th style="width:75px;">Edit</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-plink>
            <tr>
              <td style="width:50px;">{{ plink.Pos }}</td>
              <td>
                {{ plink.Linkname }}
              </td>
              <td style="width:75px;">{{ plink.URL }}</td>
              <td style="width:75px;">
                <button pButton type="button" class="ui-button-primary" (click)="editLink(plink)" icon="pi pi-pencil" title="Link bearbeiten"></button>

              </td>
            </tr>
          </ng-template>
        </p-table>

      </p-tabPanel>
    </p-tabView>
    <p-footer *ngIf="selectedProject && !showLinkEditor && !showVideo && !showUpload ">
      <div class="ui-dialog-buttonpane ui-helper-clearfix mt-1 mb-1">

        <button type="button" pButton icon="pi pi-check" (click)="saveProject()" label="  Speichern" [disabled]="!this.isValidInput()"></button>
        <button type="button" pButton icon="pi pi-times" (click)="cancelProject()" label="  Abbrechen"></button>
        <button type="button" pButton icon="pi pi-trash" (click)="deleteProject()" label="  Löschen" style="margin-left:10px" *ngIf="this.selectedProject.pId!='new-project'"></button>

      </div>
    </p-footer>
    <p-confirmDialog icon="pi pi-exclamation-triangle" [acceptLabel]="'Ja'" [rejectLabel]="'Nein'"></p-confirmDialog>
  </p-dialog>

